import { css } from '@emotion/react';
import _ from 'underscore';
import { useFormContext } from 'react-hook-form';
import t from 'react-translate';
// components
import NvCheckbox from 'shared/components/inputs/nv-checkbox';

import baseStyles from './base-styles';

type NeverActiveProps = {
  checkboxName: string,
  disableOn?: string[],
};

const NeverActive = ({
  checkboxName,
  disableOn,
}: NeverActiveProps) => {
  const styles = css`
    &.logged-in {
      ${baseStyles};
    }
  `;

  const { watch, setValue } = useFormContext();
  const [hasNeverActiveChecked = false] = watch([checkboxName]);

  const onCheckboxToggle = (e) => {
    setValue('daysInactiveChecked', false, { shouldValidate: true });
  };

  let dependentFieldChecked;
  if (disableOn.length > 0) {
    if (watch('hasCompletedJourneyChecked')) {
      // If the option "Has completed journey" has been checked and the selected value
      // is true, the "Never active" checkbox will be disabled.
      // Otherwise, Never Active will be avaiable to be checked. (NOV-84888)
      const hasCompletedJourney = watch('hasCompletedJourney');
      if (hasCompletedJourney?.value) {
        dependentFieldChecked = hasCompletedJourney;
      }
    } else {
      // Watching the rest of the dependent fields
      dependentFieldChecked = disableOn.find(filter => watch(filter));
    }
  }

  return (
    <div css={styles} className={`logged-in ${hasNeverActiveChecked ? 'on' : ''} ${dependentFieldChecked ? 'disabled' : ''}`}>
      <div className='checkbox-wrapper'>
        <NvCheckbox
          withForm
          name={checkboxName}
          label={t.JOURNEY_COMMUNICATIONS.FILTERS.ACTIVE_DAYS.NEVER_ACTIVE.DEFAULT()}
          onChange={onCheckboxToggle}
          labelClassName='text-large-regular pl-6'
          disabled={dependentFieldChecked}
        />
      </div>
    </div>
  );
};

export default NeverActive;
